import { render, staticRenderFns } from "./ModulePostcardAddons.vue?vue&type=template&id=acd83afc&scoped=true&"
import script from "./ModulePostcardAddons.vue?vue&type=script&lang=js&"
export * from "./ModulePostcardAddons.vue?vue&type=script&lang=js&"
import style0 from "./ModulePostcardAddons.vue?vue&type=style&index=0&id=acd83afc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd83afc",
  null
  
)

export default component.exports